const DataTabs = [
  { label: "Previous Visit", value: "previous" },
  { label: "Today Visit", value: "today" },
  { label: "Upcoming Visit", value: "upcoming" },
];

export default DataTabs;